export default [
  {
    path: "/",
    meta: { auth: false, public: true },
    title: "FormPage",
    name: "FormPage",
    component: () => import(`@/components/FormPage/index.vue`),
  },

  {
    path: "/preview-call",
    meta: { auth: false, public: true },
    title: "PreviewCall",
    name: "PreviewCall",
    component: () => import(`@/components/PreviewCall.vue`),
  },

  {
    path: "/titular-email/:client/:holder_uuid",
    meta: { auth: false, public: true },
    title: "TitularEmail",
    name: "TitularEmail",
    component: () => import(`@/components/ValidationPage.vue`),
  },

  {
    path: "/webforms/:client/:form",
    meta: { auth: false, public: true },
    title: "WebForms",
    name: "WebForms",
    component: () => import(`@/components/WebForms.vue`),
  },

  {
    path: "*",
    meta: {
      public: true,
    },
    redirect: {
      path: "/404",
    },
  },
];
